import { createContext } from 'react'

export type AnchorElementsContextType = {
  addAnchorElement?: (elementName: string, elementRef: React.RefObject<any>) => void
  anchorElements?: Record<string, React.RefObject<any>>
  scrollToAnchor?: (anchorName: string) => void
}

const AnchorElementsContext = createContext<AnchorElementsContextType>({})

export default AnchorElementsContext
